import axios from 'axios';
import { tokenInterceptor } from '@api/interceptors/request/tokenInterceptor';

const artlionUkApiGateway = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

artlionUkApiGateway.interceptors.request.use(
  config => tokenInterceptor(config),
  error => Promise.reject(error),
);
artlionUkApiGateway.interceptors.response.use(
  res => res,
  err => {
    return Object.assign({}, err).response;
  }
)

export { artlionUkApiGateway };